/**
 * NavOfferIcon is a component that displays a nav offer icon.
 *
 * @return {React.FC}
 */
const NavOfferIcon: React.FC = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66669 11.8335C1.66669 11.2812 2.1144 10.8335 2.66669 10.8335H18C18.5523 10.8335 19 11.2812 19 11.8335C19 12.3858 18.5523 12.8335 18 12.8335H2.66669C2.1144 12.8335 1.66669 12.3858 1.66669 11.8335Z"
        fill="#1C274C"
      />
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 22.5C7 21.9477 7.44772 21.5 8 21.5H10.6667C11.219 21.5 11.6667 21.9477 11.6667 22.5C11.6667 23.0523 11.219 23.5 10.6667 23.5H8C7.44772 23.5 7 23.0523 7 22.5ZM13 22.5C13 21.9477 13.4477 21.5 14 21.5H19.3333C19.8856 21.5 20.3333 21.9477 20.3333 22.5C20.3333 23.0523 19.8856 23.5 19.3333 23.5H14C13.4477 23.5 13 23.0523 13 22.5Z"
        fill="#1C274C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.55478 7.04927C3.98803 7.60964 3.66669 8.67474 3.66669 11.0198V21.9798C3.66669 24.3249 3.98803 25.39 4.55478 25.9504C5.12547 26.5147 6.21203 26.8332 8.58669 26.8332H23.4134C25.788 26.8332 26.8746 26.5147 27.4453 25.9504C28.012 25.39 28.3334 24.3249 28.3334 21.9798V16.5398C28.3334 15.9876 28.7811 15.5398 29.3334 15.5398C29.8856 15.5398 30.3334 15.9876 30.3334 16.5398V21.9798C30.3334 24.3147 30.0614 26.1763 28.8514 27.3726C27.6455 28.565 25.772 28.8332 23.4134 28.8332H8.58669C6.22801 28.8332 4.35457 28.565 3.14859 27.3726C1.93868 26.1763 1.66669 24.3147 1.66669 21.9798V11.0198C1.66669 8.68494 1.93868 6.82337 3.14859 5.62707C4.35457 4.43467 6.22801 4.1665 8.58669 4.1665H18C18.5523 4.1665 19 4.61422 19 5.1665C19 5.71879 18.5523 6.1665 18 6.1665H8.58669C6.21203 6.1665 5.12547 6.485 4.55478 7.04927Z"
        fill="#1C274C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6667 4.1665C26.219 4.1665 26.6667 4.61422 26.6667 5.1665V7.83317H29.3333C29.8856 7.83317 30.3333 8.28089 30.3333 8.83317C30.3333 9.38546 29.8856 9.83317 29.3333 9.83317H26.6667V12.4998C26.6667 13.0521 26.219 13.4998 25.6667 13.4998C25.1144 13.4998 24.6667 13.0521 24.6667 12.4998V9.83317H22C21.4477 9.83317 21 9.38546 21 8.83317C21 8.28089 21.4477 7.83317 22 7.83317H24.6667V5.1665C24.6667 4.61422 25.1144 4.1665 25.6667 4.1665Z"
        fill="#1C274C"
      />
    </svg>
  );
};

export default NavOfferIcon;
